import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  background-color: var(--background-gray-light);
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 6px;
  font-size: 12px;
  color: var(--text-secondary);
  line-height: 1.5;
`;

type Props = {
  children: React.ReactNode;
};

export const QuoteBlock = ({ children }: Props) => (
  <Container>"{children}"</Container>
);
